export const fullStation = `
id
title
upToDate
maintenanceModeEnabled
locale
powerStatus
updatedAt
order
ages
safetyMode
timerEnabled
location {
  id
}
experience {
  id
  launcher {
    id
  }
}
playing {
  id
  title
  imageUrl
}
leftController {
  battery
  charging
}
rightController {
  battery
  charging
}
calling
ageLimit
operatorTags{
  id
}
operatorTagsRequireAll
`;

export const tagFragment = `
  id
  text
  order
`;
